module.exports = __webpack_public_path__ + "img/monitor.a93a5e80.png";